import { FC, useEffect, useState } from 'react';
import { CloseButton } from '../../../../../lib/components/Buttons/CloseButton';
import { Tag } from '../../../../../lib/model/Tag';
import { request } from '../../../../../lib/utils/request';
import { SelectedTags } from './SelectedTags';
import { TagTypeWithColor } from './Tags/tag_type';
import { Card, Switch, message } from 'antd';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import { TagDto } from '../../../../../lib/dtos/TagDto';

const BASE_URL = process.env.REACT_APP_PERIODIC_API || '';
const BASE_URL_SIGNATURE = process.env.REACT_APP_CLIENT_CONTRACT_MANAGEMENT_API || '';

interface IProps {
	selected_contents: Tag[];
	tag_type: TagTypeWithColor;
	on_change: (tags: Tag[]) => void;
	close: () => void;
}

export const ForumSignatureTag: FC<IProps> = ({ on_change, tag_type, selected_contents, close }) => {
	const [selected_tags, set_selected_tags] = useState(selected_contents);
	const [is_loading, set_is_loading] = useState(false);
	const [has_news, set_has_news] = useState(false);
	const [periodics_list, set_periodics_list] = useState<any[]>([]);

	function insert_tag_with_color() {
		getPeriodicsList();
	}

	async function getPeriodicsList() {
		const listTags: Tag[] = [];
		const resultSeriesForSignature = (await request().get(
			`${BASE_URL_SIGNATURE}/tags/signature/book`
		)) as any[];
		console.log(resultSeriesForSignature, '  :: resultSeriesForSignature');

		if (resultSeriesForSignature && resultSeriesForSignature.length) {
			for (let i = 0; i < resultSeriesForSignature.length; i++) {
				const tags = resultSeriesForSignature[i];
				console.log(tags, '  :: tags');

				const tag: Tag = {
					id: resultSeriesForSignature[i].id,
					title: resultSeriesForSignature[i].title,
				};
				listTags.push(tag);
			}
		}

		const result = (await request().get(`${BASE_URL}/periodics`)) as any[];

		if (result && result.length) {
			for (let i = 0; i < result.length; i++) {
				const periodic = result[i];

				const periodicNumId = String(periodic.numId).replace('P', '');
				const p = periodics_list.find((v) => v.numId === periodic.numId);

				const tag: Tag = {
					id: `periodic-${periodicNumId}_edition_1-1000`,
					title: `Revistas: ${p?.acronym || periodicNumId} - De 1 a 1000`,
				};

				listTags.push(tag);
			}
		}

		const tag: Tag = {
			id: `forum-signature`,
			title: `Fórum Assinaturas`,
		};
		listTags.push(tag);
		const tagNews: Tag = {
			id: `news`,
			title: `Informativos`,
		};
		listTags.push(tagNews);
		//console.log(listTags);
		set_selected_tags([...selected_tags, ...listTags]);

		// const resultVideos = (await request().get(`${BASE_URL_VIDEOS}/tags/video`)) as any[];
		// if (resultVideos && resultVideos.length) {
		// 	for (let i = 0; i < resultVideos.length; i++) {
		// 		const vid = resultVideos[i];

		// 		const tag: Tag = {
		// 			id: vid.id,
		// 			title: vid.title,
		// 		};

		// 		listTags.push(tag);
		// 	}
		// }
	}

	async function removeForumSginatures() {
		const listTags: Tag[] = [];

		const resultSeriesForSignature = (await request().get(
			`${BASE_URL_SIGNATURE}/tags/signature/book`
		)) as any[];

		if (resultSeriesForSignature?.length) {
			for (const item of resultSeriesForSignature) {
				listTags.push({
					id: item.id,
					title: item.title,
				});
			}
		}

		// --- Buscar periódicos ---
		const result = (await request().get(`${BASE_URL}/periodics`)) as any[];

		if (result?.length) {
			for (const periodic of result) {
				const periodicNumId = String(periodic.numId).replace('P', '');
				const p = periodics_list.find((v) => v.numId === periodic.numId);

				listTags.push({
					id: `periodic-${periodicNumId}_edition_1-1000`,
					title: `Revistas: ${p?.acronym || periodicNumId} - De 1 a 1000`,
				});
			}
		}

		// --- Remover news ---
		const filtered = selected_tags.filter((tag) => tag.id !== 'news');

		// --- Remover forum-signature ---
		const noForumSignature = filtered.filter((tag) => tag.id !== 'forum-signature');

		// --- Remover todos os items presentes em listTags ---
		const idsToRemove = new Set(listTags.map((t) => t.id));

		const finalList = noForumSignature.filter((tag) => !idsToRemove.has(tag.id));

		return finalList;
	}

	async function remove_tag() {
		const listTags: Tag[] = [];
		const new_contents = await removeForumSginatures();
		const tagNews: Tag = {
			id: `item`,
			title: `item`,
		};
		listTags.push(tagNews);
		//console.log(listTags);
		set_selected_tags([...new_contents, ...listTags]);
	}

	async function getPeriodics() {
		set_is_loading(true);
		const result = await request().get(`${BASE_URL}/periodics`);
		set_periodics_list(result as any[]);
		set_is_loading(false);
	}

	useEffect(() => {
		getPeriodics();
	}, []);

	useEffect(() => {
		on_change(selected_tags);
		const news = !!selected_tags.find((content) => String(content.id).includes('forum-signature'));
		set_has_news(news);
	}, [selected_tags]);

	return (
		<section className='flex flex-col w-full'>
			<div className='flex flex-row justify-between'>
				<Card
					style={{ background: '#fff', marginTop: 1, width: '100%' }}
					bodyStyle={{ width: '100%' }}
					className='flex flex-row rounded border border-gray-100 p-4 bg-gray-50 flex-wrap max-w-lg'
				>
					<div className='grid grid-cols-2'>
						<div className='col-span-2 block mb-3'>
							<label>
								<span className='text-xs mr-1'>Liberar Fórum Assinaturas?</span>
							</label>
							<br />
							<Switch
								checkedChildren={<CheckOutlined />}
								unCheckedChildren={<CloseOutlined />}
								checked={has_news}
								onChange={has_news ? remove_tag : insert_tag_with_color}
							/>
						</div>
					</div>
				</Card>
			</div>
		</section>
	);
};
